// flags.js
let globalFlag = false;

export const setGlobalFlag = (value) => {
  globalFlag = value;
};

export const getGlobalFlag = () => {
  return globalFlag;
};